module.exports = __webpack_public_path__ + "img/if_7.962674fc.png";